import { motion } from "framer-motion";
import { SituationCards } from "@/components/SituationCards";
import { ArrowRight, Radar } from "lucide-react";

export function Hero({ onPick, onExplore }) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 tac-grid pointer-events-none" />
      <div
        className="absolute inset-x-0 top-0 h-[520px] pointer-events-none opacity-[0.35]"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 0%, rgba(204,255,0,0.15) 0%, rgba(0,229,255,0.06) 40%, transparent 70%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-20 pb-16 md:pb-24">
        <div className="flex flex-col items-start gap-6">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-3 font-mono-tac text-[10px] tracking-[0.28em] text-[color:var(--lg-cyan)]"
          >
            <Radar size={14} />
            <span>LIFEGRID // REAL-WORLD ASSISTANCE ENGINE</span>
            <span className="live-dot" aria-hidden />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05, duration: 0.6 }}
            className="font-display text-[44px] sm:text-6xl lg:text-[86px] font-extrabold uppercase leading-[0.92] tracking-tight max-w-5xl"
          >
            When life goes <span className="text-lime-accent">wrong</span>,<br />
            know what to do <span className="text-cyan-accent">next</span>.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.12, duration: 0.6 }}
            className="max-w-2xl text-base sm:text-lg text-[color:var(--lg-text-2)]"
          >
            LIFEGRID turns confusing real-world situations into clear, immediate actions. Don&apos;t panic. Find the next
            safe step.
          </motion.p>
        </div>

        <div className="mt-10 md:mt-14">
          <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-3">
              <span className="font-mono-tac text-[11px] tracking-[0.28em] text-[color:var(--lg-text-3)]">
                STEP&nbsp;01 // SELECT
              </span>
              <span className="h-px w-14 bg-[color:var(--lg-line-strong)]" />
            </div>
            <button
              onClick={onExplore}
              className="btn-tactile ghost hidden sm:inline-flex"
              data-testid="hero-explore-button"
            >
              Explore Lifegrid <ArrowRight size={14} />
            </button>
          </div>

          <div className="mb-5">
            <h2 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight">
              What&apos;s happening?
            </h2>
          </div>

          <SituationCards onPick={onPick} />
        </div>
      </div>
    </section>
  );
}
